import React from 'react';

/**
 * Context to store devices object config from ResponsiveView
 * */
const DevicesContext = React.createContext({
  device: {},
});

export default DevicesContext;
